import axios from '../axios'
// 充值标准列表
export const getBaseRechargeNormPage = (data) => {
  return axios({
    url: '/api/sys/getBaseRechargeNormPage',
    method: 'post',
    data
  })
}
//充值标准列表删除
export const deleteBaseRechargeNorms = data => {
  return axios({
      url: '/api/sys/deleteBaseRechargeNorms',
      method: 'post',
      data
  })
};
//其他应收总合计
export const getTuReceivablesOtherSum = data => {
  return axios({
      url: '/api/sys/tu/getTuReceivablesOtherSum',
      method: 'post',
      data
  })
};
//其他应付总合计
export const getTuPaymentOtherSum = data => {
  return axios({
      url: '/api/sys/tu/getTuPaymentOtherSum',
      method: 'post',
      data
  })
};
//总合计
export const getTuRechargeReportSum = data => {
  return axios({
      url: '/api/sys/tu/getTuRechargeReportSum',
      method: 'post',
      data
  })
};
//付款表总合计
export const getTuPaymentSum = data => {
  return axios({
      url: '/api/sys/tu/getTuPaymentSum',
      method: 'post',
      data
  })
};
//充值标准列表保存修改
export const saveBaseRechargeNorm = data => {
  if (!data.id) {
    return axios({
        url: '/api/sys/saveBaseRechargeNorm',
        method: 'post',
        data
    })
  } else {
    return axios({
        url: '/api/sys/updateBaseRechargeNorm',
        method: 'post',
        data
    })
  }
};


// 充值赠送金额
export const getRechargeNormByAmount = (data) => {
  return axios({
    url: '/api/sys/getRechargeNormByAmount',
    method: 'post',
    data
  })
}

// 充值明细列表
export const getTuRechargeDetailPage = (data) => {
  return axios({
    url: '/api/sys/tu/getTuRechargeDetailPage',
    method: 'post',
    data
  })
}
//充值明细列表删除
export const deleteTuRechargeDetails = data => {
  return axios({
      url: '/api/sys/tu/deleteTuRechargeDetails',
      method: 'post',
      data
  })
};
//充值明细列表保存
export const saveTuRechargeDetail = data => {
  return axios({
      url: '/api/sys/tu/saveTuRechargeDetail',
      method: 'post',
      data
  })
};
//充值明细列表审核
export const auditRecharge = data => {
  return axios({
      url: '/api/sys/tu/auditRecharge',
      method: 'post',
      data
  })
};
// 充值明细列表导出
export const doRechargeDetailExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doRechargeDetailExport',
    method: 'post',
    data
  })
}

// 其他应收列表
export const getTuReceivablesOtherPage = (data) => {
  return axios({
    url: '/api/sys/tu/getTuReceivablesOtherPage',
    method: 'post',
    data
  })
}
// 其他应收列表保存
export const saveTuReceivablesOther = (data) => {
  return axios({
    url: '/api/sys/tu/saveTuReceivablesOther',
    method: 'post',
    data
  })
}
// 其他应收列表修改
export const updateTuReceivablesOther = (data) => {
  return axios({
    url: '/api/sys/tu/updateTuReceivablesOther',
    method: 'post',
    data
  })
}
// 其他应收列表删除
export const deleteTuReceivablesOthers = (data) => {
  return axios({
    url: '/api/sys/tu/deleteTuReceivablesOthers',
    method: 'post',
    data
  })
}
// 其他应收列表审核
export const receivablesAudit = (data) => {
  return axios({
    url: '/api/sys/tu/receivablesAudit',
    method: 'post',
    data
  })
}
// 其他应收列表反审核
export const receivablesUnAudit = (data) => {
  return axios({
    url: '/api/sys/tu/receivablesUnAudit',
    method: 'post',
    data
  })
}

// 其他应付列表
export const getTuPaymentOtherPage = (data) => {
  return axios({
    url: '/api/sys/tu/getTuPaymentOtherPage',
    method: 'post',
    data
  })
}
// 其他应付列表保存
export const saveTuPaymentOther = (data) => {
  return axios({
    url: '/api/sys/tu/saveTuPaymentOther',
    method: 'post',
    data
  })
}
// 其他应付列表修改
export const updateTuPaymentOther = (data) => {
  return axios({
    url: '/api/sys/tu/updateTuPaymentOther',
    method: 'post',
    data
  })
}
// 其他应付列表删除
export const deleteTuPaymentOthers = (data) => {
  return axios({
    url: '/api/sys/tu/deleteTuPaymentOthers',
    method: 'post',
    data
  })
}
// 其他应付列表审核
export const paymentOtherAudit = (data) => {
  return axios({
    url: '/api/sys/tu/paymentOtherAudit',
    method: 'post',
    data
  })
}
// 其他应付列表反审核
export const paymentOtherUnAudit = (data) => {
  return axios({
    url: '/api/sys/tu/paymentOtherUnAudit',
    method: 'post',
    data
  })
}

// 付款表列表
export const getTuPaymentPage = (data) => {
  return axios({
    url: '/api/sys/tu/getTuPaymentPage',
    method: 'post',
    data
  })
}
// 付款表列表保存
export const saveTuPayment = (data) => {
  return axios({
    url: '/api/sys/tu/saveTuPayment',
    method: 'post',
    data
  })
}
// 付款表列表修改
export const updateTuPayment = (data) => {
  return axios({
    url: '/api/sys/tu/updateTuPayment',
    method: 'post',
    data
  })
}
// 付款表列表删除
export const deleteTuPayments = (data) => {
  return axios({
    url: '/api/sys/tu/deleteTuPayments',
    method: 'post',
    data
  })
}
// 付款表列表审核
export const paymentAudit = (data) => {
  return axios({
    url: '/api/sys/tu/paymentAudit',
    method: 'post',
    data
  })
}
// 付款表列表反审核
export const paymentUnAudit = (data) => {
  return axios({
    url: '/api/sys/tu/paymentUnAudit',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Recharge.js